import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=25dff354&scoped=true"
import script from "./Remark.vue?vue&type=script&lang=js"
export * from "./Remark.vue?vue&type=script&lang=js"
import style0 from "./Remark.vue?vue&type=style&index=0&id=25dff354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dff354",
  null
  
)

export default component.exports